import { render, staticRenderFns } from "./JsonModelDisplayComponent.vue?vue&type=template&id=fb432d60"
import script from "./JsonModelDisplayComponent.vue?vue&type=script&lang=ts"
export * from "./JsonModelDisplayComponent.vue?vue&type=script&lang=ts"
import style0 from "./JsonModelDisplayComponent.vue?vue&type=style&index=0&id=fb432d60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports